module.exports = __webpack_public_path__ + "static/img/top1_i5_nav.86a08d0e.png";